module.exports = __webpack_public_path__ + "gb.4df1e7ea.svg";